import { REPORT_OPTIONS } from '$fbusiness/enums/options/orderStatus';
import { INPUT } from '$gbusiness/enums';
import { insertEmptyOption } from '$gbusiness/helpers/input';
import InputRowModel from '$gbusiness/models/inputRow';

export const ORDER_STATUS_FILTER = (vendors: any = []): Array<InputRowModel> => [
  {
    items: [
      {
        input: INPUT.SELECT,
        label: 'SCREEN.ORDERS.COLS.STATUS',
        disableFastField: true,
        gridSize: 4,
        value: 'status',
        shrink: true,
        options: insertEmptyOption(
          (REPORT_OPTIONS || []).map(({ label, value }) => ({
            label: 'INPUT.OPTION.' + label,
            value,
          })),
          'All',
          '',
        ),
      },
      {
        input: INPUT.SELECT,
        label: 'SCREEN.REPORT.COLS.VENDOR',
        disableFastField: true,
        // isHidden: () => vendors.length < 1,
        gridSize: 4,
        value: 'vendorId',
        shrink: true,
        options: insertEmptyOption(
          (vendors || []).map((v) => ({
            labelText: v.name,
            value: v.id,
          })),
          'All',
          '',
        ),
      },
    ],
  },
];
